<template>
    <div class="Profile">
        <navigation-bar Close/>
        <div class="main">
            <custom-card class="user-block">
                <div class="avatar" @click="switchImage">
                    <div class="image_empty"  v-if="form.avatar===''"/>
                    <el-image :src="form.avatar" fit="cover" v-else lazy/>
                    <img class="camera" src="@/assets/images/camera.svg">
                </div>
            </custom-card>
            <custom-card>
                <el-row type="flex" justify="end">
                    <el-col :span="4" class="text-right">
                        <el-button @click="$router.push({name: 'EditProfile'})" type="text" class="pr-3 pl-3"><img
                                src="@/assets/images/edit_black.svg" alt="編輯" style="width: 22px;"></el-button>
                    </el-col>
                </el-row>
                <border-input noBorder>
                    <img slot="icon" src="@/assets/images/profile/name.svg">
                    <el-row slot="label" type="flex" justify="space-between">
                        <el-col :span="8">姓名</el-col>
                        <el-col :span="16" class="text-right">核對身份用</el-col>
                    </el-row>
                    <template slot="input">
                        <OpenEyes v-if="form.name" :value="form.name"/>
                        <span v-else class="empty">尚未輸入</span>
                    </template>
                </border-input>
                <border-input noBorder>
                    <img slot="icon" src="@/assets/images/profile/nickname.svg">
                    <el-row slot="label" type="flex" justify="space-between">
                        <el-col :span="8">暱稱</el-col>
                        <el-col :span="16" class="text-right">顯示於APP中</el-col>
                    </el-row>
                    <div slot="input">
                        <span v-if="form.nickname">{{form.nickname}}</span>
                        <span v-else class="empty">尚未輸入</span>
                    </div>
                </border-input>
                <border-input labelText="手機" noBorder>
                    <img slot="icon" src="@/assets/images/profile/phone.svg">
                    <template slot="input">
                        <OpenEyes v-if="form.phone" :value="form.phone"/>
                        <span v-else class="empty">尚未輸入</span>
                    </template>
                </border-input>
                <border-input labelText="生日" noBorder>
                    <img slot="icon" src="@/assets/images/profile/birth.svg">
                    <template slot="input">
                        <OpenEyes v-if="form.birth" :value="form.birth"/>
                        <span v-else class="empty">尚未輸入</span>
                    </template>
                </border-input>
                <border-input labelText="性別" noBorder>
                    <img slot="icon" src="@/assets/images/profile/name.svg">
                    <template slot="input">
                        <span v-if="form.gender">{{form.gender}}</span>
                        <span v-else class="empty">尚未輸入</span>
                    </template>
                </border-input>
                <border-input labelText="信箱" noBorder>
                    <img slot="icon" src="@/assets/images/profile/email.svg">
                    <template slot="input">
                        <OpenEyes v-if="form.email" :value="form.email"/>
                        <span v-else class="empty">尚未輸入</span>
                    </template>
                </border-input>
                <border-input labelText="聯絡地址" noBorder>
                    <img slot="icon" src="@/assets/images/profile/house.svg">
                    <template slot="input">
                        <span v-if="form.address">{{form.address}}</span>
                        <span v-else class="empty">尚未輸入</span>
                    </template>
                </border-input>
            </custom-card>
            <comm-dialog :value="dialog.isShowDialog"
                         :outerContent="dialog.dialogMsg"
                         :isCancel="dialog.cancelable"
                         :positive-label="dialog.positiveLabel"
                         :is-text-box="dialog.isTextBox"
                         @result="onCommDialogClose" />
            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true">
            </loading>
            <toast/>
        </div>
    </div>
</template>

<script>
    import CustomCard from '@/components/CustomCard.vue';
    import BorderInput from '@/components/BorderInput.vue';
    import CommDialog from "@/components/CommDialog";
    import * as mutationTypes from '@/store/mutationTypes';
    import Toast from "@/components/Toast.vue";
    import {getFileExtension, notNull} from '@/util/common';
    import OpenEyes from "@/components/OpenEyes";
    import {getCryptoUserInfo, getCryptoUserPhone, saveCryptoUserInfo} from "@/util/cryptoLocalStorage";

    export default {
        name: "Profile",
        components: {CustomCard, BorderInput, CommDialog, Toast, OpenEyes},
        data() {
            return {
                isLoading: false,
                form: {
                    avatar: '',
                    name: '',
                    nickname: '',
                    phone: '',
                    birth: '',
                    gender: '',
                    email: '',
                    address: ''
                },
                dialog: {
                    isShowDialog: false,
                    dialogMsg: '',
                    cancelable: false,
                    positiveLabel: '確定',
                    isTextBox: false,
                },
            }
        },
        created() {

        },
        mounted() {

            let self = this;
            self.isLoading = true;
            self.callGetUserInfoApi()
                .then( (data) => {
                    self.isLoading = false;
                    saveCryptoUserInfo(data);
                    self.refreshUserData();
                })
                .catch( (error) => {
                    self.isLoading = false;
                    self.$store.commit(mutationTypes.SHOW_TOAST, error);
                });

            //監聽截圖事件
            document.addEventListener("onTookScreenshot",function(){
                // Receive notification when screenshot is ready;
                self.dialog.isShowDialog = true;
                self.dialog.dialogMsg = "注意!!\n" +
                    "您現在截圖之訊息可能含有敏感資訊，請勿分享給他人造成資訊外洩";
            });
        },
        methods: {

            /** 取得個人資訊 */
            callGetUserInfoApi: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`GetUserInfoWithId${{}} ${json => {

                        if (notNull(json.data)) {
                            resolve(json.data);
                        } else {
                            reject();
                        }
                    }}`;
                });
            },

            /** 更新個人資料 */
            refreshUserData: function () {
                // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                const userData = getCryptoUserInfo();
                this.form.avatar = userData.picture;
                this.form.name = userData.name;
                this.form.nickname = userData.nickName;
                // this.form.phone = localStorage.getItem('phone') || "";
                this.form.phone = getCryptoUserPhone();
                this.form.birth = userData.birthdayAt;
                switch (userData.gender) {
                    case 0:
                        this.form.gender = '?';
                        break;
                    case 1:
                        this.form.gender = '男';
                        break;
                    case 2:
                        this.form.gender = '女';
                        break;
                }
                this.form.email = userData.email;
                this.form.address = userData.city + userData.township + userData.address;
            },

            /** cordova 選取照片 */
            cordovaImagePicker: function () {
                // let self = this;
                let isCordova = !!window.cordova;
                if(isCordova){

                    // window.AdvancedImagePicker.present({
                    //     // config here
                    //     min: Number(1),
                    //     minCountMessage: '最少要選取一張照片',
                    //     max: Number(1),
                    //     maxCountMessage: '最多選取一張照片',
                    //
                    // }, function(success) {
                    //     if (success !== null && success.length > 0) {
                    //         if (success[0].src !== null && success[0].src !== '') {
                    //             self.onSuccess(success[0].src);
                    //         }
                    //     } else {
                    //         alert('');
                    //     }
                    //
                    // }, function (error) {
                    //     console.error(JSON.stringify(error));
                    //     self.onFail(error);
                    //
                    // });

                }
            },
            /** 開啓圖片選取器 */
            switchImage: function () {
                let isCordova = !!window.cordova;
                if(isCordova) {
                    // this.cordovaImagePicker();
                } else {
                    //cordova-plugin-camera使用的照片選取段落，當做 web 取用相片
                    this.capturePhoto();
                }

            },
            capturePhoto: function () {
                navigator.camera.getPicture(this.onSuccess, this.onFail, {
                    //拍照
                    quality: 50,
                    correctOrientation: true,
                    // eslint-disable-next-line no-undef
                    destinationType: Camera.DestinationType.FILE_URL,
                });
                this.dialogVisible = false
            },
            getPhoto: function () {
                navigator.camera.getPicture(this.onSuccess, this.onFail, {
                    quality: 50,
                    // eslint-disable-next-line no-undef
                    destinationType: Camera.DestinationType.FILE_URL,
                    // eslint-disable-next-line no-undef
                    sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM
                });
            },

            /** 取得檔案 */
            onSuccess: function (imageData) {
                // eslint-disable-next-line no-undef
                var ft = new FileTransfer();
                // eslint-disable-next-line no-undef
                var options = new FileUploadOptions();

                //判斷副檔名來改變上傳的檔案類型，FileUploadOptions 預設檔名是 image.jpg，若內容與檔名的格式不符會出現錯誤
                let extFilename = getFileExtension(imageData);
                if(extFilename === 'png'){
                    options.fileName = 'image.png';
                }

                var params = {
                    "folder": "/headerPhoto",
                    "apiKey": "41e1ac4a1ad16b11275cd9121b572225"
                }
                options.params = params

                this.isLoading = true;
                let serverUrl = process.env.VUE_APP_FILE_HOST + '/api'
                ft.upload(imageData, serverUrl, this.uploadCompleted, this.uploadedFail, options)
            },
            /** 檔案選取失敗 */
            onFail: function (message) {

            },
            /** 檔案上傳成功 */
            uploadCompleted: function (r) {

                this.isLoading = false;

                if (JSON.parse(r.response).status) {
                    const url = JSON.parse(r.response).data[0]
                    const imgUrl = process.env.VUE_APP_FILE_HOST + '/' + url
                    this.form.avatar = imgUrl
                    this.updateAvatar(url)
                }
            },
            /** 檔案上傳失敗 */
            uploadedFail: function (error) {
                this.isLoading = false;

                alert("An error has occurred: Code = " + error.code);
            },

            /** 更新大頭圖 */
            updateAvatar: function (imageUrl) {
                this.isLoading = true;
                this.$http.fetchWithAuth`UpdateUserPicture${{
                    'picture': imageUrl,
                }}
                ${json => {
                    this.isLoading = false;
                    alert(json.message)
                }}`;
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                this.dialog.isShowDialog = false;
            },
        }
    }
</script>
<style lang="less" scoped src="../../../less/personalInfo.less"/>
